/*
 * Mobile swipe-through-images for collection grid cards.
 * Hooks into the theme's existing `product-grid-item-image` custom element via its
 * public attribute contract (data-grid-image / data-grid-current-image / loading),
 * the same contract the theme's own hover-cycle logic uses on desktop. Nothing in
 * theme.js is modified.
 */
(function () {
  var MOBILE_BREAKPOINT = 768;
  var SWIPE_THRESHOLD = 40;
  var DIRECTION_LOCK_THRESHOLD = 8;

  function isMobileViewport() {
    return (window.innerWidth || document.documentElement.clientWidth) < MOBILE_BREAKPOINT;
  }

  function getImages(container) {
    return Array.prototype.slice.call(container.querySelectorAll('[data-grid-image]'));
  }

  function getCurrentIndex(images) {
    for (var i = 0; i < images.length; i++) {
      if (images[i].hasAttribute('data-grid-current-image')) return i;
    }
    return 0;
  }

  function ensureDots(container) {
    var images = getImages(container);
    if (images.length < 2) return null;
    var wrap = container.parentElement;
    if (!wrap) return null;
    var dots = wrap.querySelector('[data-mobile-swipe-dots]');
    if (dots) return dots;
    dots = document.createElement('div');
    dots.className = 'product-grid-item__mobile-dots';
    dots.setAttribute('data-mobile-swipe-dots', '');
    var currentIndex = getCurrentIndex(images);
    for (var i = 0; i < images.length; i++) {
      var dot = document.createElement('span');
      dot.className = 'product-grid-item__mobile-dot' + (i === currentIndex ? ' is-active' : '');
      dots.appendChild(dot);
    }
    wrap.appendChild(dots);
    return dots;
  }

  function ensureDotsIfMobile(container) {
    if (!isMobileViewport()) return;
    ensureDots(container);
  }

  function updateDots(container, index) {
    var wrap = container.parentElement;
    if (!wrap) return;
    var dots = wrap.querySelector('[data-mobile-swipe-dots]');
    if (!dots) return;
    var children = dots.children;
    for (var i = 0; i < children.length; i++) {
      children[i].classList.toggle('is-active', i === index);
    }
  }

  function goToImage(container, index) {
    var images = getImages(container);
    if (!images.length) return;
    var target = images[(index + images.length) % images.length];
    images.forEach(function (img) {
      img.removeAttribute('data-grid-current-image');
    });
    target.setAttribute('data-grid-current-image', 'true');
    if (target.getAttribute('loading') !== 'eager') {
      target.setAttribute('loading', 'eager');
    }
    updateDots(container, images.indexOf(target));
  }

  function suppressNextClick(link) {
    if (!link) return;
    link.addEventListener(
      'click',
      function (e) {
        e.preventDefault();
        e.stopPropagation();
      },
      { capture: true, once: true }
    );
  }

  var touchState = null;

  document.addEventListener(
    'touchstart',
    function (e) {
      if (!isMobileViewport()) return;
      var container = e.target.closest && e.target.closest('[data-grid-images]');
      if (!container) return;
      var images = getImages(container);
      if (images.length < 2) return;
      var touch = e.touches[0];
      touchState = {
        container: container,
        startX: touch.clientX,
        startY: touch.clientY,
        moved: false,
        horizontal: false
      };
      ensureDots(container);
    },
    { passive: true }
  );

  document.addEventListener(
    'touchmove',
    function (e) {
      if (!touchState) return;
      var touch = e.touches[0];
      var dx = touch.clientX - touchState.startX;
      var dy = touch.clientY - touchState.startY;
      if (!touchState.horizontal && (Math.abs(dx) > DIRECTION_LOCK_THRESHOLD || Math.abs(dy) > DIRECTION_LOCK_THRESHOLD)) {
        touchState.horizontal = Math.abs(dx) > Math.abs(dy);
      }
      if (touchState.horizontal) {
        touchState.moved = true;
        if (e.cancelable) e.preventDefault();
      }
    },
    { passive: false }
  );

  document.addEventListener(
    'touchend',
    function (e) {
      if (!touchState) return;
      var state = touchState;
      touchState = null;
      if (!state.horizontal || !state.moved) return;
      var touch = e.changedTouches[0];
      var dx = touch.clientX - state.startX;
      if (Math.abs(dx) < SWIPE_THRESHOLD) return;
      var images = getImages(state.container);
      var currentIndex = getCurrentIndex(images);
      var nextIndex = dx < 0 ? currentIndex + 1 : currentIndex - 1;
      goToImage(state.container, nextIndex);
      var link = state.container.closest('[data-grid-link]');
      suppressNextClick(link);
    },
    { passive: true }
  );

  function initExistingDots() {
    document.querySelectorAll('[data-grid-images]').forEach(ensureDotsIfMobile);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initExistingDots);
  } else {
    initExistingDots();
  }

  // Collection pages can re-render the grid via AJAX (filters, pagination).
  // Watch for newly-inserted cards so dots appear without requiring a first touch.
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('[data-grid-images]')) ensureDotsIfMobile(node);
          if (node.querySelectorAll) {
            node.querySelectorAll('[data-grid-images]').forEach(ensureDotsIfMobile);
          }
        });
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('theme:resize:width', initExistingDots);
})();
